import React from 'react';
import { styled, alpha } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import Box from '@mui/material/Box';

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha('#222C2F', 0.8),
  '&:hover': {
    backgroundColor: alpha('#222C2F', 0.9),
  },
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: 0,
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: '#fff',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    fontSize: 14,
    [theme.breakpoints.up('sm')]: {
      width: '20ch',
      '&:focus': {
        width: '25ch',
      },
    },
  },
}));

const SearchBar = ({ searchQuery, setSearchQuery, inHeader }) => {
  return (
    <Box sx={{ 
      width: '100%', 
      padding: inHeader ? '8px' : '16px',
      maxWidth: inHeader ? 'none' : 'none'
    }}>
      <Search>
        <SearchIconWrapper>
          <SearchIcon sx={{ color: '#AAB4C8', fontSize: inHeader ? '18px' : '20px' }} />
        </SearchIconWrapper>
        <StyledInputBase
          placeholder="Search farms..."
          inputProps={{ 'aria-label': 'search' }}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </Search>
    </Box>
  );
};

export default SearchBar;
